/* ============================================================
   MyPokea — Boîtes neuves : un coffret scellé par génération
   ============================================================ */
document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("boites-grid");
  if (!root) return;
  const gens = POKE.GENERATIONS;
  root.innerHTML = gens.map(g => {
    const sealed = !g.upcoming;
    // deterministic box price ≈ count × avg unit, rounded to .90
    const boxPrice = sealed ? Math.round((g.count * 7.4) / 10) * 10 + 9.90 : null;
    return `
      <div class="boite-card ${g.upcoming ? 'upcoming' : ''}" style="--gc:${g.color};">
        <div class="boite-media" style="--gc:${g.color};">
          <image-slot id="boite-${g.gen}" shape="rect" placeholder="Coffret ${g.name} scellé"></image-slot>
          <span class="boite-seal">${g.upcoming ? 'Bientôt 2026' : 'Scellé · 未開封'}</span>
          <span class="boite-kanji" aria-hidden="true">${g.kanji}</span>
        </div>
        <div class="boite-info">
          <div class="boite-region">GEN ${String(g.gen).padStart(2,'0')} · ${g.years}</div>
          <div class="boite-name">Coffret ${g.name}</div>
          <div class="boite-meta">${g.count ? g.count + ' figurines Kids · série complète' : 'Composition à venir'}</div>
          <div class="boite-row">
            <div class="boite-price">
              ${sealed ? `<small>Boîte complète</small><strong>${boxPrice.toFixed(2).replace('.', ',')} €</strong>` : `<small>Pré-commande</small><strong>—</strong>`}
            </div>
            <button class="boite-add" data-gen="${g.gen}" ${g.upcoming ? 'disabled' : ''}>${g.upcoming ? 'Bientôt' : 'Ajouter'}</button>
          </div>
        </div>
      </div>
    `;
  }).join("");

  root.querySelectorAll("[data-gen]").forEach(b => b.onclick = () => {
    const gen = gens.find(g => g.gen === parseInt(b.dataset.gen, 10));
    if (!gen || gen.upcoming) return;
    const boxPrice = Math.round((gen.count * 7.4) / 10) * 10 + 9.90;
    Cart.add({ id: `box-g${gen.gen}`, name: `Coffret ${gen.name} scellé`, price: boxPrice, variant: `Boîte neuve · ${gen.count} figurines Kids`, bg: gen.color, qty: 1 });
    b.textContent = "✓ Ajouté"; setTimeout(() => { b.textContent = "Ajouter"; }, 1000);
    if (window.openCart) openCart();
  });
});
